import { FlakinessReport } from '@flakiness/flakiness-report';
import { ReportUtils } from '@flakiness/sdk/browser';
import { Ranges } from './ranges.js';
import { Stats } from './stats/stats.js';
import { TestIndex } from './stats/testIndex.js';
import { TestOutcomes } from './stats/testOutcomes.js';
import { WireTypes } from './wireTypes.js';


export function createFakeReportCommit(report: FlakinessReport.Report): WireTypes.Commit {
  return {
    isFakeCommit: true,
    commitId: report.commitId,
    timestamp: report.startTimestamp,
    message: '',
  };
}


export class WireReport {
  public readonly envs: WireTypes.RunEnvironment[];
  public readonly report: FlakinessReport.Report;
  public readonly commitId: FlakinessReport.CommitId;
  public readonly url?: string;
  public readonly duration: FlakinessReport.DurationMS;

  private _testToWireTest = new Map<FlakinessReport.Test, WireTypes.Test>();
  private _testIdToTest = new Map<Stats.TestId, FlakinessReport.Test>();

  constructor(report: FlakinessReport.Report) {
    this.report = report;
    this.commitId = report.commitId;
    this.url = report.url;
    this.duration = report.duration;
    this.envs = report.environments.map(env => Stats.jsonEnvToWireEnv(Stats.flakinessEnvToJSONEnv(report, env)));
    ReportUtils.visitTests(report, (test, parents) => {
      const wireTest = Stats.flakinessTestToWireTypesTest(test, parents);
      this._testToWireTest.set(test, wireTest);
      this._testIdToTest.set(wireTest.testId, test);
    });
  }

  testsMask(testIndex: TestIndex): TestOutcomes.TestRanges {
    const testIdx = new Set<Stats.TestIndex>();
    for (const testId of this._testIdToTest.keys()) {
      const t = testIndex.testIndex(testId);
      if (t !== undefined)
        testIdx.add(t);
    }
    return Ranges.fromList([...testIdx]);
  }

  wireTest(test: FlakinessReport.Test) {
    return this._testToWireTest.get(test);
  }

  fkTest(testId: Stats.TestId) {
    return this._testIdToTest.get(testId);
  }
}
